import React from "react";
import { notification, Spin } from "antd";

export const axiosNotification = (
  cargando,
  respuestaServer,
  msgs = {
    cargando: "Cargando...",
    correcto: "Carga exitosa",
    error: "Error en la carga",
  }
) => {
  if (cargando) {
    notification.info({
      style: {
        fontSize: 10,
      },
      message: msgs["cargando"],
      icon: <Spin />,
      placement: "topRight",
      duration: 2.5,
      key: "info",
    });
  } else {
    if (respuestaServer === 200) {
      notification.success({
        message: msgs["correcto"],
        placement: "topRight",
        duration: 2.5,
        key: "success",
      });
    }

    if (respuestaServer === 400) {
      notification.error({
        message: msgs["error"],
        style: {
          fontSize: 10,
        },
        placement: "topRight",
        duration: 2.5,
        key: "error",
      });
    }
  }
};
